import React from 'react';

class SingleItemLoadingState extends React.Component {

  render() {
    return(
      <div className="br5 background-white cs-shadow mb3">
        <div className="p3">
          <div
            className="fs-md cs-bg-light-gray animated-background"
            style={{width: "100px", height: "20px"}}>
          </div>
          <div className="mt2 flexbox-wrapper">
            <span
              className="mr2 cs-bg-light-gray border-circle flexbox-center animated-background"
              style={{width: "32px", height: "32px"}}>
            </span>
            <span
              className="fs-xxl cs-bg-light-gray flexbox-center animated-background"
              style={{width: "100px", height: "20px", marginTop: "6px"}}>
            </span>
          </div>
        </div>
      </div>
    );
  }

}

export default SingleItemLoadingState;
